/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, Highcharts, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';
  var TimeRangeViewer = mp.marketing.trends.TimeRangeViewer;

  var IPHONE_7 = `iPhone 7`,
    IPHONE_7_PLUS = `iPhone 7 Plus`,
    OTHER_IPHONE = `Other`,
    NOT_AN_IPHONE = `NOT AN IPHONE`,
    SERIES_ORDER = [IPHONE_7, IPHONE_7_PLUS, OTHER_IPHONE];

  var iphone_model_name = function(model_id) {
    if (model_id.match(/^iPhone9,(1|3)$/)) {
      return IPHONE_7;
    } else if (model_id.match(/^iPhone9,(2|4)$/)) {
      return IPHONE_7_PLUS;
    } else if (model_id.match(/^iPhone[0-9]+,\d$/)) {
      return OTHER_IPHONE;
    }
    return NOT_AN_IPHONE;
  };


  ns.IPhone7 = mp.marketing.trends.widgets.TrendReport.extend({
    get_defaults() {
      return {
        date_range: new DateRange(new Date(2016, 8, 1), new Date()),
        report_unit: `week`,
      };
    },

    get_queries() {
      var unit = this.session.get(`report_unit`);
      var date_range = this.session.get(`date_range`);

      return {
        base: {
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'query_name': `ios_device_models`,
          'to_date': date_range.to().toString(mp.utility.default_date_format),
          unit,
        },
      };
    },

    get_chart_params(query_data) {
      delete query_data.base.Unknown;

      var parse_date = function(date_string) {
        var date = Date.parseExact(date_string, `yyyy-MM-dd HH:mm:ss`) ||
                       Date.parseExact(date_string, `yyyy-MM-dd`);
        // dates from arb are in PST (project time)
        date.setTimezone(`PST`);
        return date;
      };

      var models_to_series = _.groupBy(query_data.base, function(_, model_id) {
        return iphone_model_name(model_id);
      });
      _.each(SERIES_ORDER, function(model) {
        if (!_.has(models_to_series, model)) {
          models_to_series[model] = [];
        }
      });
      delete models_to_series[NOT_AN_IPHONE];

      var models_to_one_series = {};
      var totals = {};
      _.each(models_to_series, function(model_series, model_name) {
        var this_model = {};

        _.each(model_series, function(series) {
          _.each(series, function(value, date) {
            if (parse_date(date).getTime() < mp.report.globals.utc_now) {
              if (_.isUndefined(this_model[date])) {
                this_model[date] = 0;
              }
              if (_.isUndefined(totals[date])) {
                totals[date] = 0;
              }
              this_model[date] += value;
              totals[date] += value;
            }
          });
        });
        models_to_one_series[model_name] = this_model;
      });

      var chart_data = _.chain(models_to_one_series)
        .pairs()
        .sortBy(function(model_series_pair) {
          return SERIES_ORDER.indexOf(model_series_pair[0]);
        }, this)
        .map(function(model_series_pair, i) {
          var model = model_series_pair[0],
            series = model_series_pair[1];

          return {
            name: model,
            color: mp.charts.nth_color(i, this.color_scheme),
            data: _.map(series, function(val, date) {
              var unixtime = parse_date(date).getTime();
              var percent = 0;
              if (totals[date]) {
                percent = (val / totals[date]) * 100;
              }
              return [unixtime, percent];
            }).sort(),
            visible: true,
          };
        }, this)
        .value();

      var xaxis_config;
      if (this.session.get(`report_unit`) === `hour`) {
        xaxis_config = {
          'type': `datetime`,
          'tickInterval': 4 * 60 * 60 * 1000, // 4 hrs
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e, %l %p`, this.value);
            },
            'rotation': -45,
          },
        };
      } else {
        xaxis_config = {
          'type': `datetime`,
          'minTickInterval': 24 * 60 * 60 * 1000, // 24 hrs
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e`, this.value);
            },
            'rotation': -45,
          },
        };
      }

      return {
        'xAxis': xaxis_config,
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': chart_data,
        'tooltip': {
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'crosshairs': true,
          'pointFormat': `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>`,
          'shared': true,
          'useHTML': false,
          'valueDecimals': 2,
        },
        'chart': {'marginBottom': 75, 'height': 450},
      };
    },

    _update_multi_selector(chart_data) {
      mp.marketing.trends.widgets.TrendReport.prototype._update_multi_selector.call(this, chart_data);

      // Increase width of IPHONE_7_PLUS multi-selector item to fit full label
      var dropdown = this.multi_selector.dropdowns[SERIES_ORDER.indexOf(IPHONE_7_PLUS)];
      dropdown.container.css(`width`, 160)
        .find(`.title`).css(`width`, 80);
    },

    getDownloadName() {
      return ns.IPhone7.nice_name;
    },
  });

  ns.IPhone7.slug = `iphone_7`;
  ns.IPhone7.nice_name = `iPhone 7 adoption`;
  ns.IPhone7.description = `How quickly will people start using the new iPhone 7?`;
  ns.IPhone7.chart_type = `line`;
  ns.IPhone7.color_scheme = `colorblind`;
  ns.IPhone7.asterisk = `Time/Date in UTC`;
  ns.IPhone7.view_class = TimeRangeViewer;
  ns.IPhone7.time_units = [`day`, `week`, `month`];
});

}.call(window));